import { ENDPOINTS } from 'utils/api/callApi'
import { IRate } from '../contractLanes/types'

export enum ROUTING_GUIDE_ACTION_TYPES {
  FETCH_ROUTING_GUIDE_REQUEST = 'FETCH_ROUTING_GUIDE_REQUEST',
  FETCH_ROUTING_GUIDE_SUCCESS = 'FETCH_ROUTING_GUIDE_SUCCESS',
  FETCH_ROUTING_GUIDE_FAILURE = 'FETCH_ROUTING_GUIDE_FAILURE',
}

export enum ROUTING_GUIDE_COUNT_ACTION_TYPES {
  FETCH_ROUTING_GUIDE_COUNT_REQUEST = 'FETCH_ROUTING_GUIDE_COUNT_REQUEST',
  FETCH_ROUTING_GUIDE_COUNT_SUCCESS = 'FETCH_ROUTING_GUIDE_COUNT_SUCCESS',
  FETCH_ROUTING_GUIDE_COUNT_FAILURE = 'FETCH_ROUTING_GUIDE_COUNT_FAILURE',
}

export const getRoutingGuide = (transfixLaneId: string, specificLaneId: string) => {
  return {
    type: '',
    payload: {
      callApi: true,
      requestData: {
        endpoint: ENDPOINTS.laneMetrics,
        group: 'reserved?per_page=50',
        id: `${transfixLaneId}/${specificLaneId}`,
      },
      actionTypes: Object.keys(ROUTING_GUIDE_ACTION_TYPES),
    },
  }
}

export const getRoutingGuideCounts = (transfixLaneId: string, specificLaneId: string) => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: ENDPOINTS.laneMetrics,
      group: 'counts',
      id: `${transfixLaneId}/${specificLaneId}`,
    },
    actionTypes: Object.keys(ROUTING_GUIDE_COUNT_ACTION_TYPES),
  },
})

export enum LANE_MODAL_ACTION_TYPES {
  LANE_MODAL_OPEN = 'LANE_MODAL_OPEN',
  LANE_MODAL_CLOSE = 'LANE_MODAL_CLOSE',
}
export const openLaneModal = (lane?: IRate) => ({
  type: LANE_MODAL_ACTION_TYPES.LANE_MODAL_OPEN,
  payload: { lane },
})
